export const getCurrentPathName = (
  baseUrl: string,
  location: Location | URL = window.location,
) => (location.origin + location.pathname).replace(baseUrl, '');
